"use strict";

export default class DeliveryRoute{
    
    constructor(){
        this.scaDeliveryMethodsSelector = 'sca-storepickup-methods';
        this.deliveryRouteContainerSelector = '.wd-delivery-route-container';
        this.deliveryRouteStopContainerSelector = '.wd-delivery-route-stop';
        this.deliveryRouteSelector = 'wd-delivery-route-dd';
        this.deliveryRouteStopSelector = 'wd-delivery-route-stop-dd';
        this.deliveryRouteErrorMsgSelector = '.wd-delivery-route-error-msg';
        this.deliveryRouteStopErrorMsgSelector = '.wd-delivery-route-stop-error-msg';
        this.checkoutBtnSelector = '[name="checkout"]';
    }

    set clearDeliveryRouteFields(clearFlag = true){
        let deliveryRouteElem = document.getElementById(this.deliveryRouteSelector);
        let deliveryRouteStopElem = document.getElementById(this.deliveryRouteStopSelector);
        let deliveryRouteErrorElem = document.querySelector(this.deliveryRouteErrorMsgSelector);
        let deliveryRouteStopErrorElem = document.querySelector(this.deliveryRouteStopErrorMsgSelector);
        
        deliveryRouteElem && clearFlag ? deliveryRouteElem.value = "" : null;
        deliveryRouteStopElem && clearFlag ? deliveryRouteStopElem.value = "" : null;
        deliveryRouteErrorElem && clearFlag ? deliveryRouteErrorElem.style.display = "none" : null;
        deliveryRouteStopErrorElem && clearFlag ? deliveryRouteStopErrorElem.style.display = "none" : null;
        
    }

    set hideCheckoutBtns(hideBtn = true){
        let checkoutBtns = document.querySelectorAll(this.checkoutBtnSelector);
        if(checkoutBtns){
            checkoutBtns = Array.prototype.slice.call(checkoutBtns);
            if(checkoutBtns.length > 0){
                checkoutBtns.map(checkoutBtn => {
                    checkoutBtn.style.setProperty("display",(hideBtn ? "none" : "inline-block"),"important");
                }); 
            }
        }
    }

    get deliveryRoutes(){
        return window.delivery_route.routes;
    }

    get cartAttributes(){
        return window.delivery_route.cart_attributes;
    }

    get deliveryTabOpened(){
        return storepickup_noapi.deliveryTabOpened();
    }
    
    bindDeliveryTabEvent(){
        let __this = this;
        let scaDeliveryTabElem = document.getElementById(this.scaDeliveryMethodsSelector);
        let deliveryRouteContainer = document.querySelector(this.deliveryRouteContainerSelector);
        if(deliveryRouteContainer){
            if(this.deliveryTabOpened){
                deliveryRouteContainer.style.display = "block";
                setTimeout(() => {
                    __this.hideCheckoutBtns = true;
                }, 1000);
                
            }else{
                deliveryRouteContainer.style.display = "none";
                this.clearDeliveryRouteFields = true;
                setTimeout(() => {
                    __this.hideCheckoutBtns = false;
                }, 1000);
            }
        }
        if(scaDeliveryTabElem){
            scaDeliveryTabElem.addEventListener('click',function(e) {
                if(deliveryRouteContainer){
                    if(__this.deliveryTabOpened){
                        deliveryRouteContainer.style.display = "block";
                        setTimeout(() => {
                            __this.hideCheckoutBtns = true;
                        }, 1000);
                    }else{
                        deliveryRouteContainer.style.display = "none";
                        __this.clearDeliveryRouteFields = true;
                        setTimeout(() => {
                            __this.hideCheckoutBtns = false;
                        }, 1000);
                    }
                }       
            });
        }
        
    }

    bindDeliveryRouteEvent(){
        let __this = this;
        let deliveryRouteElem = document.getElementById(this.deliveryRouteSelector);
        let deliveryRouteStopElem = document.getElementById(this.deliveryRouteStopSelector);
        let deliveryRouteStopContainerElem = document.querySelector(__this.deliveryRouteStopContainerSelector);
        if(deliveryRouteElem){
            deliveryRouteElem.addEventListener("change",function(e) {
                let selVal = e.target.options[e.target.options.selectedIndex].getAttribute('data-slug') ?? '';
                let deliveryRoutes = __this.deliveryRoutes.filter((route) => {
                    return route.route_slug === selVal;
                });
                deliveryRouteStopElem.options.length = 0
                __this.hideCheckoutBtns = true;
                if(deliveryRouteStopContainerElem){
                    deliveryRouteStopContainerElem.style.display = "none";
                }
                if(deliveryRoutes.length > 0){
                    let selRoute = deliveryRoutes[0];
                    let routeStops = selRoute.route_delivery_stops ?? [];
                    if(routeStops.length > 0){
                        let defaultOption = document.createElement('option');
                        defaultOption.text = "Choose your stop";
                        defaultOption.value = "";
                        deliveryRouteStopElem.add(defaultOption);
                        routeStops.map((stop) => {
                            let option = document.createElement('option');
                            option.text = stop.stop_title+' / '+stop.stop_location;
                            option.value = stop.stop_title+' / '+stop.stop_location;
                            deliveryRouteStopElem.add(option);
                        });
                        if(deliveryRouteStopContainerElem){
                            deliveryRouteStopContainerElem.style.display = "block";
                        }
                    }
                }
            });
        }
        if(deliveryRouteStopElem){
            deliveryRouteStopElem.addEventListener("change",function(e) {
                let selRoute = deliveryRouteElem.value ?? '';
                let selStop = e.target.value ?? '';
                if(selRoute != '' && selStop != ''){
                    __this.hideCheckoutBtns = false;
                }else{
                    __this.hideCheckoutBtns = true;
                }
            });
        }
    }

    init(){
        let __this = this;
        setTimeout(() => {
            __this.bindDeliveryTabEvent();
            __this.bindDeliveryRouteEvent();
        }, 2500);
    }
}